import React, { useState, useEffect } from 'react';
import './Footer.css';

const Footer = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-socials">
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            <img src="Icons/Icon_Facebook.png" alt="Facebook" />
          </a>
          <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
            <img src="Icons/Icon_X.png" alt="Twitter" />
          </a>
          <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
            <img src="Icons/Icon_LinkedIn.png" alt="LinkedIn" />
          </a>
        </div>
        <div className="footer-legal">
          <a href="/privacy-policy" className="footer-legal-link">Privacy Policy</a>
          <a href="/terms-of-service" className="footer-legal-link">Terms of Service</a>
          <a href="/legal-disclaimer" className="footer-legal-link">Legal Disclaimer</a>
        </div>
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} GalaxyAdvisors AG. All rights reserved.
        </p>
      </div>
      {showButton && (
        <button className="back-to-top-btn" onClick={scrollToTop} aria-label="Back to top">
          <div className="back-to-top-icon-container">
            <img src="Icons/Icon_Arrow.png" alt="Back to top" className="back-to-top-icon" />
          </div>
        </button>
      )}
    </footer>
  );
  
};

export default Footer;
